function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import React from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { hideModal } from '../../redux/actions';
import text from '../../text';
import { Button } from '../button';
import Icon from '../icon/Icon';
import LinkButton from '../button/LinkButton';
import PropTypes from 'prop-types';
import classNames from 'classnames';
export var CONFIRM_MODAL = 'CONFIRM_MODAL';
var ConfirmModal = function(param) {
    var show = param.show, onConfirm = param.onConfirm, title = param.title, body = param.body, _param_cancelLabel = param.cancelLabel, cancelLabel = _param_cancelLabel === void 0 ? text('cancel') : _param_cancelLabel, _param_okLabel = param.okLabel, okLabel = _param_okLabel === void 0 ? text('ok') : _param_okLabel, isAttentionIconVisible = param.isAttentionIconVisible, isFooterButtonReversed = param.isFooterButtonReversed, isButtonFullWidth = param.isButtonFullWidth, isLinkButton = param.isLinkButton, isCloseButtonVisible = param.isCloseButtonVisible;
    var dispatch = useDispatch();
    var onHide = function() {
        return dispatch(hideModal(CONFIRM_MODAL));
    };
    var onOk = function() {
        onConfirm();
        onHide();
    };
    return /*#__PURE__*/ React.createElement(Modal, {
        centered: true,
        show: show,
        onHide: onHide
    }, /*#__PURE__*/ React.createElement(Modal.Header, _object_spread({
        className: "centered"
    }, isCloseButtonVisible && {
        closeButton: true
    }), /*#__PURE__*/ React.createElement("div", {
        className: "d-flex flex-column align-items-center justify-content-center"
    }, isAttentionIconVisible ? /*#__PURE__*/ React.createElement(Icon, {
        icon: "circled-exclamation",
        className: "mb-5"
    }) : null, /*#__PURE__*/ React.createElement("h3", null, title))), /*#__PURE__*/ React.createElement(Modal.Body, {
        className: "text-center"
    }, body), /*#__PURE__*/ React.createElement(Modal.Footer, {
        className: classNames({
            'd-flex flex-fill flex-column-reverse': isFooterButtonReversed
        })
    }, isLinkButton ? /*#__PURE__*/ React.createElement(LinkButton, {
        onClick: function(e) {
            e.preventDefault();
            onHide();
        },
        className: classNames({
            'mt-3': isFooterButtonReversed
        })
    }, cancelLabel) : /*#__PURE__*/ React.createElement(Button, {
        variant: "outline-primary",
        onClick: onHide,
        className: classNames({
            'mt-2': isFooterButtonReversed,
            'full-width': isButtonFullWidth
        })
    }, cancelLabel), /*#__PURE__*/ React.createElement(Button, {
        autoFocus: true,
        onClick: onOk,
        className: classNames({
            'full-width': isButtonFullWidth
        })
    }, okLabel)));
};
ConfirmModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onConfirm: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    body: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.node
    ]),
    cancelLabel: PropTypes.string,
    okLabel: PropTypes.string,
    isAttentionIconVisible: PropTypes.bool,
    isFooterButtonReversed: PropTypes.bool,
    isButtonFullWidth: PropTypes.bool,
    isLinkButton: PropTypes.bool,
    isCloseButtonVisible: PropTypes.bool
};
ConfirmModal.defaultProps = {
    cancelLabel: text('cancel'),
    okLabel: text('ok'),
    isAttentionIconVisible: false,
    isFooterButtonReversed: false,
    isButtonFullWidth: true,
    isLinkButton: false,
    isCloseButtonVisible: false
};
export default ConfirmModal;
